import { render, staticRenderFns } from "./headingComponent.vue?vue&type=template&id=128cce51&scoped=true"
import script from "./headingComponent.vue?vue&type=script&lang=js"
export * from "./headingComponent.vue?vue&type=script&lang=js"
import style0 from "./headingComponent.vue?vue&type=style&index=0&id=128cce51&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128cce51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128cce51')) {
      api.createRecord('128cce51', component.options)
    } else {
      api.reload('128cce51', component.options)
    }
    module.hot.accept("./headingComponent.vue?vue&type=template&id=128cce51&scoped=true", function () {
      api.rerender('128cce51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/headingComponent.vue"
export default component.exports